import * as React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { ConfirmProvider, ToastProvider, TooltipProvider } from "@cm/ui";
import "./styles.css";
import { queryClient } from "./lib/query";
import { BrandProvider, useBrand } from "./lib/brand";
import { SessionProvider } from "./lib/session";
import { buildRouter } from "./routes";

function App() {
  const brand = useBrand();
  const platform = brand.kind === "platform";
  const router = React.useMemo(() => buildRouter(platform), [platform]);
  return (
    <SessionProvider platform={platform}>
      <RouterProvider router={router} />
    </SessionProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ToastProvider>
          <ConfirmProvider>
            <BrandProvider>
              <App />
            </BrandProvider>
          </ConfirmProvider>
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
